import { useMemo } from "react";

import { PrintBasicInfoTableLayout } from "../../../layout";

type Props = {
	roomNum: number;
};

export const BasicInfoRoomNumOfPrintComposition = ({ roomNum }: Props) => {
	const roomNumText = useMemo(() => {
		return `${roomNum} 部屋`;
	}, [roomNum]);

	return <PrintBasicInfoTableLayout title="部屋数" content={roomNumText} />;
};
